import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { useNls } from '../../nls/nlsProvider'
import { waMeInviteLink } from '../../utils/whatsappLinks'

export type HelperAppAccessBlockedNoticeProps = {
  workspaceName: string
  sendingE164?: string | null
}

export const HelperAppAccessBlockedNotice = ({
  workspaceName,
  sendingE164,
}: HelperAppAccessBlockedNoticeProps) => {
  const { t } = useNls()
  const waUrl = (sendingE164 ? waMeInviteLink(sendingE164) : null) ?? 'https://wa.me/'

  return (
    <main
      data-testid="helper-app-access-blocked-notice"
      className="min-h-0 flex-1 overflow-y-auto overscroll-contain grid place-items-center px-6 py-8"
      style={{
        paddingBottom: 'calc(var(--helper-bottom-chrome-height, 5.75rem) + 1rem + env(safe-area-inset-bottom, 0px))',
      }}
    >
      <div className="text-center flex flex-col items-center gap-4 max-w-sm">
        <div
          className="h-20 w-20 rounded-full bg-[var(--surface-card)] border border-[var(--border-subtle)] grid place-items-center text-3xl shadow-sm text-[#25D366]" // mosaic-keep: brand (WhatsApp green)
          aria-hidden="true"
        >
          <WhatsAppIcon style={{ fontSize: '36px' }} />
        </div>
        <h2 className="text-lg font-semibold text-[var(--text-strong)] leading-snug">
          {t('NLSHelperAppAccessBlockedNotice', { workspaceName })}
        </h2>
        <a
          href={waUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="helper-whatsapp-wa-me-btn"
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl font-medium text-sm text-white bg-[#25D366] hover:bg-[#20ba5a] active:scale-95 transition-all shadow-sm" // mosaic-keep: brand (WhatsApp green)
        >
          <WhatsAppIcon fontSize="inherit" style={{ fontSize: '18px' }} />
          <span>{t('NLSHelperAppAccessBlockedAction')}</span>
        </a>
      </div>
    </main>
  )
}
